/**
 * Os passos do guia passo a passo e a ordem entre eles (protótipo do Claude Design de 28/10/2026;
 * conhecimento/analises/PROPOSTA-GUIA-PRIMEIROS-LEADS.md, seção 4). Aqui só a estrutura: o que
 * cada passo mostra fica em GuiaCartao/GuiaBalao, e quando ele avança, em useGuiaControle.
 */
export type GuiaModulo = 'places' | 'phones' | 'emails';

export type PassoId =
  // Marco 1 · Quem você quer encontrar
  | 'escolher'
  // Marco 2 · Monte a busca
  | 'tipo'
  | 'extensao'
  | 'licenca'
  | 'campo_termo'
  | 'campo_lugar'
  | 'campo_alcance'
  | 'campo_fontes'
  | 'campo_ddd'
  | 'comecar'
  | 'explicacao'
  // Marco 3 · Deixe a busca trabalhar
  | 'buscando'
  | 'nada'
  | 'aba_fechada'
  // Marco 4 · Seus contatos (o guia termina quando a lista abre; pedido do Marcelo, 28/10/2026)
  | 'aviso_teste'
  | 'abrir_lista'
  // Concluído
  | 'fim';

export const PASSOS: readonly PassoId[] = [
  'escolher',
  'tipo',
  'extensao',
  'licenca',
  'campo_termo',
  'campo_lugar',
  'campo_alcance',
  'campo_fontes',
  'campo_ddd',
  'comecar',
  'explicacao',
  'buscando',
  'nada',
  'aba_fechada',
  'aviso_teste',
  'abrir_lista',
  'fim',
];

export function isPasso(value: unknown): value is PassoId {
  return typeof value === 'string' && (PASSOS as readonly string[]).includes(value);
}

/** Índice do marco (0 a 3); 4 é o guia concluído. */
export function marcoDe(passo: PassoId): number {
  switch (passo) {
    case 'escolher':
      return 0;
    case 'buscando':
    case 'nada':
    case 'aba_fechada':
      return 2;
    case 'aviso_teste':
    case 'abrir_lista':
      return 3;
    case 'fim':
      return 4;
    default:
      return 1;
  }
}

/** Passos em que a tela da ferramenta já explica: o guia fica quieto, só como pílula. */
export function passoQuieto(passo: PassoId): boolean {
  return passo === 'extensao' || passo === 'explicacao';
}

/** Os campos explicados um a um, por tipo de busca, antes do "Começar a captura". */
export const CAMPOS: Record<GuiaModulo, readonly PassoId[]> = {
  places: ['campo_termo', 'campo_lugar', 'campo_alcance'],
  phones: ['campo_termo', 'campo_fontes', 'campo_ddd'],
  emails: ['campo_termo', 'campo_fontes'],
};

export function isCampo(passo: PassoId): boolean {
  return passo.startsWith('campo_');
}

/** O passo depois de um campo (o último leva ao "Começar a captura"). */
export function proximoCampo(modulo: GuiaModulo, passo: PassoId): PassoId {
  const campos = CAMPOS[modulo];
  const i = campos.indexOf(passo);
  return i >= 0 && i < campos.length - 1 ? campos[i + 1]! : 'comecar';
}

/** Os passos do marco 2 em que a janela de captura precisa estar aberta. */
export function passoNaJanela(passo: PassoId): boolean {
  return isCampo(passo) || passo === 'comecar';
}
